export const RCP_PAGE_HEADER_TEXT = `recipes`;
/* export const RCP_PAGE_PARA_TEXT = `Sandwiches, salads and more: check out our delicious recipes and savor the flavor`;*/
export const RCP_SW_HEADER_TEXT = 'sandwiches';
export const RCP_PZ_HEADER_TEXT = 'pizzas & calzones';
export const RCP_ES_HEADER_TEXT = 'Entrees & Sides';
export const RCP_APT_HEADER_TEXT = 'Appetizers';
export const BTN_SEE_MORE = 'see more';
export const BTN_SEE_LESS = 'see less';